export default "__VITE_ASSET__0qVsb_ic__"